import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Account from '../../../containers/Account/Account';

const SUBTAB_PATHS = {
  '/': '',
  '/:url': '',
  'linkedin-import': 'linkedin-import',
};

const ProfileBase = () => (
  <Routes>
    <Route>
      {Object.keys(SUBTAB_PATHS).map((path) => (
        <Route exact path={path} key={path} element={<Account tab="profile" subTab={SUBTAB_PATHS[path]} />} />
      ))}
    </Route>
  </Routes>
);

export default ProfileBase;
